import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navItems, brand } from '../mock';
import { useBooking } from '../context/BookingContext';
import { booking } from '../mock';

const Navbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { openBooking } = useBooking();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Pages whose hero is light-colored need the navbar in solid/dark style even at top
  const lightHeroPages = ['/about'];
  const solid = scrolled || lightHeroPages.includes(location.pathname);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solid ? 'bg-[#FBFAF8]/90 backdrop-blur-md shadow-[0_1px_30px_-12px_rgba(36,16,51,0.25)] py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="bg-white rounded-md px-2.5 py-1.5 shadow-[0_2px_12px_-5px_rgba(36,16,51,0.25)] transition-transform duration-500 group-hover:scale-105">
            <img
              src={brand.logoCombo}
              alt="The Answer Group Consulting"
              className="h-11 w-auto object-contain"
            />
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`nav-link text-[0.72rem] tracking-luxe uppercase transition-colors ${
                solid
                  ? (location.pathname === item.to ? 'active text-[#43265E]' : 'text-[#3A2E45] hover:text-[#43265E]')
                  : (location.pathname === item.to ? 'active text-white' : 'text-[#E7E2EE] hover:text-white')
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden xl:block">
          <button
            onClick={() => openBooking(booking.alignmentLab, 'Book a Session')}
            className="btn-plum rounded-full px-7 py-2.5 text-sm tracking-luxe uppercase"
          >
            Book Now
          </button>
        </div>

        <button className={`xl:hidden transition-colors ${solid ? 'text-[#43265E]' : 'text-white'}`} onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
          {mobileOpen ? <X className="w-7 h-7" strokeWidth={1.5} /> : <Menu className="w-7 h-7" strokeWidth={1.5} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`xl:hidden overflow-hidden transition-all duration-500 ${
          mobileOpen ? 'max-h-[640px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="bg-[#FBFAF8] px-6 py-6 flex flex-col gap-5 border-t border-[#E7E2EE] mt-3">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-sm tracking-luxe uppercase ${
                location.pathname === item.to ? 'text-[#43265E]' : 'text-[#3A2E45]'
              }`}
            >
              {item.label}
            </Link>
          ))}
          <button
            onClick={() => openBooking(booking.alignmentLab, 'Book a Session')}
            className="btn-plum rounded-full px-7 py-3 text-sm tracking-luxe uppercase mt-2"
          >
            Book Now
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
